<template>
  <div class="tip-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="stage">
          <img class="star-fx" :src="imgStarFx" alt="" />
          <div class="card">
            <div class="header" />
            <div class="body">
              <div class="message">{{ message }}</div>
            </div>
            <div class="btns">
              <img class="btns-img" :src="imgKnowBtns" alt="" />
              <button
                class="btn-hit"
                type="button"
                aria-label="知道了"
                @click.stop="onConfirm"
              />
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'TipModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    /** 提示文案，如：领取时间未开始 */
    message: {
      type: String,
      default: '领取时间未开始'
    }
  },
  data() {
    return {
      imgStarFx: require('@/assets/imgs/xibNewCustomerGift/luyuanStarFx.png'),
      imgKnowBtns: require('@/assets/imgs/xibNewCustomerGift/luyuanTipKnowBtns.png')
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
/* 设计稿 750 ÷ 2 */
.tip-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 12px 0;
  }

  .stage {
    position: relative;
    width: 376px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .star-fx {
    position: absolute;
    left: 0;
    top: -30px;
    width: 376px;
    height: 280px;
    object-fit: contain;
    object-position: center top;
    pointer-events: none;
    z-index: 0;
  }

  .card {
    position: relative;
    z-index: 1;
    width: 317.5px;
    margin-top: 48px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    filter: drop-shadow(0 0 10px rgba(188, 244, 246, 0.95));
  }

  .header {
    width: 297px;
    height: 70.5px;
    background: url('~@/assets/imgs/xibNewCustomerGift/luyuanModalTitleBg.png')
      no-repeat center top;
    background-size: 297px 70.5px;
    flex-shrink: 0;
    position: relative;
    z-index: 2;
  }

  .body {
    width: 297px;
    margin-top: -1px;
    padding: 8px 24px 108px;
    box-sizing: border-box;
    background: #e8fdff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
  }

  .message {
    width: 100%;
    font-size: 24px;
    line-height: 1.35;
    color: #1c9aaf;
    text-align: center;
    word-break: break-word;
  }

  .btns {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 317.5px;
    height: 124px;
    z-index: 3;
  }

  .btns-img {
    display: block;
    width: 317.5px;
    height: 124px;
  }

  .btn-hit {
    position: absolute;
    left: 50%;
    top: 33px;
    transform: translateX(-50%);
    width: 170px;
    height: 42px;
    padding: 0;
    border: 0;
    background: transparent;
    outline: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
}
</style>
